var $fb4baf837c8a96f6$exports = {};
$fb4baf837c8a96f6$exports = {
  "help": "Ohje",
  "info": "Tiedot"
};
export { $fb4baf837c8a96f6$exports as default };